function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.75 0h15L30 11.1v22.2c0 2.035-1.688 3.7-3.75 3.7H3.731C1.67 37 0 35.335 0 33.3L.019 3.7C.019 1.665 1.687 0 3.75 0zm0 33.3h22.5V12.95h-9.375V3.7H3.75v29.6zM23 17H7v3h16v-3zM7 22h16v3H7v-3zm11 5H7v3h11v-3z",
  fill: "#000"
});
function SvgCtUploadConfirmInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 37,
    viewBox: "0 0 30 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default "data:image/svg+xml,%3csvg width='30' height='37' viewBox='0 0 30 37' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath id='Union' fill-rule='evenodd' clip-rule='evenodd' d='M3.75 0H18.75L30 11.1V33.3C30 35.335 28.3125 37 26.25 37H3.73125C1.66875 37 0 35.335 0 33.3L0.0187504 3.7C0.0187504 1.665 1.6875 0 3.75 0ZM3.75 33.3H26.25V12.95H16.875V3.7H3.75V33.3ZM23 17H7V20H23V17ZM7 22H23V25H7V22ZM18 27H7V30H18V27Z' fill='black'/%3e %3c/svg%3e";
export { SvgCtUploadConfirmInfoIcon as ReactComponent };